module.exports = __webpack_public_path__ + "img/664e00abaa3bdce8b40652f44afe9009.png";